import { first } from 'lodash-es'
import { useIntl } from 'react-intl'

import { QueryLoadingManager } from '@b-stock/fe-core/bstock-next/components'
import {
  type OrchestratedListingDetails,
  inventoryGroupsQuery,
} from '@b-stock/fe-core/bstock-next/queries'
import { FormattedMessage, SpinnerDots } from '@b-stock/fe-core/bstock-react'
import { CommonStrings } from '@b-stock/fe-core/locale'

import { calculateShipmentDetails } from '@/buyer-portal/components/features/listing/Shipment/utils'

export const ShipmentSize = ({
  listing,
}: {
  listing: OrchestratedListingDetails
}) => {
  const group = first(listing.lot.groups)
  // Note from merge
  //  this should eventually get added to the listingListingDetails query
  // this isn't final component and will be replace by `Shipping Summary`
  const inventoryGroupsQueryResult = inventoryGroupsQuery.useQuery(
    listing.lot._id
  )
  const { formatMessage } = useIntl()
  const { shipping } = listing

  return (
    <QueryLoadingManager
      {...inventoryGroupsQueryResult}
      LoadingComponent={SpinnerDots}
    >
      {({ data }) => {
        let groupType = group?.type
        if (!groupType && data?.groups && data.groups.length > 0) {
          groupType = data.groups[0]?.type
        }
        const { numberOfUnits } = calculateShipmentDetails(data?.groups || [])
        return (
          <FormattedMessage
            id="Auction.details.shipmentSize.value"
            values={{
              transportMode: shipping?.transportMode
                ? formatMessage(
                    {
                      id: `Auction.details.shipmentSize.transportMode.${shipping.transportMode}`,
                      defaultMessage: `{numberOfShipments} ${shipping.transportMode}`,
                    },
                    {
                      // Hardcoded to 1 (for now)
                      numberOfShipments: shipping.truckCount,
                    }
                  )
                : CommonStrings.NotAvailableAbbr.format(formatMessage),
              packaging: formatMessage(
                {
                  id: `Auction.details.shipmentSize.groupType.${groupType}`,
                  defaultMessage: `{numberOfUnits} ${groupType}`,
                },
                {
                  numberOfUnits: numberOfUnits,
                }
              ),
            }}
          />
        )
      }}
    </QueryLoadingManager>
  )
}
